import Modal from "./superstore-native-modal.js";

const mobileFilterMedia = window.matchMedia("(max-width: 859px)");
const filterTriggerSelector = "[data-productgrid-trigger-filters]";
const filterContentSelector = "[data-productgrid-filters-content]";
const filterModal = new Modal();
const searchSection = document
  .querySelector('[data-section-type="static-search"]')
  ?.closest(".shopify-section");
const searchResults = searchSection?.querySelector("[data-html]");

document.addEventListener("click", (event) => {
  if (!(event.target instanceof Element)) return;

  const trigger = event.target.closest(filterTriggerSelector);

  if (
    !trigger ||
    !mobileFilterMedia.matches ||
    document.body.classList.contains("modal-visible") ||
    !document.querySelector(filterContentSelector)
  ) {
    return;
  }

  event.preventDefault();
  filterModal.open(filterContentSelector, "productgrid-filters", trigger);
});

document.addEventListener("kk:close-productgrid-filters", () => {
  if (filterModal.isOpen()) filterModal.close();
});

if (searchResults) {
  const searchResultsObserver = new MutationObserver(() => {
    if (filterModal.isOpen()) filterModal.close();
  });

  searchResultsObserver.observe(searchResults, { childList: true });
}
